import { useMainButton } from "../tg";

type Props = {
  onBack: () => void;
};

// Заглушка экрана настроек. Полноценный контент появится позже,
// сейчас юзеру нужен куда-то приходить от кнопки шестерёнки на Home.
export default function Settings({ onBack }: Props) {
  // Дублируем «Назад» в MainButton — на случай если юзер не привык к Telegram BackButton.
  useMainButton({ text: "Назад", onClick: onBack });

  return (
    <div className="screen">
      <header>
        <h1>Настройки</h1>
      </header>
      <div className="card">Скоро.</div>
    </div>
  );
}
